module.exports = __webpack_public_path__ + "img/PumpWithVFD.0d7a1965.png";